import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const membershipFormStyles = (theme: Theme) => ({
	root: {
		position: 'relative',
		backgroundColor: '#1A1A1A',
		height: '100%',

		'*::-webkit-scrollbar': {
			width: '4px',
		},

		'*::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		},
	},
	content: {
		flex: 1,
		position: 'relative',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		px: { xs: '16px', sm: '64px' },
		py: { xs: '30px', sm: '32px' },
		gap: '24px',
	},
	body: {
		flex: 1,
		display: 'flex',
		flexDirection: { xs: 'column', md: 'row' },
		alignItems: { xs: 'center', md: 'flex-start' },
		justifyContent: { xs: 'flex-start', md: 'center' },
		alignSelf: 'center',
		gap: '16px',
		overflow: { xs: 'auto', md: 'hidden' },
		pr: { xs: '5px', md: 0 },
		width: { sm: '500px', md: '856px', lg: '956px' },
	},
	placeholder: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		maxWidth: '634px',
		maxHeight: '100%',
		overflow: 'auto',
	},
	placeholderTitle: {
		color: '#FFFFFF',
		textAlign: 'center',
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '24px',
		fontWeight: 600,
		textTransform: 'uppercase',
	},
	placeholderDescription: {
		color: '#C5C5C5',
		textAlign: 'center',
		fontFamily: 'Hind',
		fontSize: '16px',
		fontWeight: 400,
	},
	membershipFormLeftPart: {
		background: '#00000066',
		borderRadius: '8px',
		width: { xs: '100%', md: '320px' },
	},
	editMembershipButton: {
		position: 'absolute',
		right: '13px',
		top: 0,
		transform: 'translateY(-50%)',
		padding: '5px 13px',
		border: `0.76px solid #FFFFFF4D`,
		backgroundColor: `#0000004D`,
		fontFamily: 'Montserrat',
		fontSize: '11px',
		fontWeight: 500,
		lineHeight: '16px',
		borderRadius: '25px',
		gap: '4px',
		color: '#FFFFFF',
		backdropFilter: 'blur(8px)',

		"& >svg": {
			width: '10px',
			height: '10px',
		},

		"&:hover": {
			backgroundColor: `#0000004D`,
		},

		"&:disabled": {
			color: '#FFFFFF',
			opacity: 0.2,
		}
	},
	membershipInfoHost: {
		color: '#FFF',
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '24px',
	},
	membershipFormRightPart: {
		flex: { xs: 'unset', md: 1 },
		width: { xs: '100%', md: 'auto' },
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		overflow: { xs: 'unset', md: 'auto' },
	},
	orderSummary: {
		padding: '24px 12px',
		borderRadius: '0 0 8px 8px',
		backgroundColor: '#0000004D',
		position: 'relative',
		userSelect: 'none',
		overflow: 'hidden',
		flex: '0 1 auto',
	},
	membershipTierAmount: {
		color: '#FFFFFF',
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '16px',
		fontWeight: 500,
		lineHeight: '16px',
	},
	membershipMonthlyFrequency: {
		color: 'rgba(255, 255, 255, 0.60)',
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 500,
	},
	membershipDescription: {
		color: 'rgba(255, 255, 255, 0.90)',
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 500,
		lineHeight: '21px',
	},
	membershipTierSelect: {
		'& .MuiSelect-select': {
			p: '2px 6px',
			color: '#FFFFFF',
			fontFamily: 'Montserrat',
			fontSize: '13px',
			fontWeight: 500,
			lineHeight: '21px',
			backgroundColor: '#00000080',
			borderRadius: '25px',

			'&.MuiInputBase-input': {
				pr: '24px',
			},
		},

		'& .MuiSelect-icon': {
			width: '16px',
			height: '16px',
			right: '6px',
		},
	},
	membershipTierSelectMenuItemText: {
		color: '#FFF',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '21px',
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	form: {
		borderRadius: '8px',
		backgroundColor: '#00000080',
		p: { xs: '16px', ms: '24px' },
	},
	backButton: {
		color: '#FFFFFF',
		border: '1px solid #FFFFFF66',
		width: '48px',
		height: '48px',
		mb: '24px',

		'&.Mui-disabled': {
			color: 'rgba(255, 255, 255, 0.6)'
		},
	},
	title: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#FFFFFF',
	},
	secondaryButton: {
		p: '6px 12px',
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '14px',
		color: '#FFFFFF',
		borderRadius: '25px',
		backgroundColor: '#FFFFFF1A',

		'&:hover': {
			backgroundColor: '#FFFFFF4D',
		},

		'&:disabled': {
			color: '#FFFFFF',
			opacity: 0.2,
		},
	},
	appliedPromocode: {
		width: '102px',
		padding: '11px 15px',
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '15px',
		color: '#FFFFFF',
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
		userSelect: 'none',

		"& >svg": {
			width: '19px',
			height: '19px',
		}
	},
	applyPromocodeButton: {
		width: '66px',
		marginTop: '1.5px',
		padding: '13px 15px',
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '15px',
		border: '1px solid #FFFFFF',
		color: '#FFFFFF',
		borderRadius: '25px',

		'&:hover': {
			background: '#FFFFFF',
			color: '#000000',
		},
		'&:disabled': {
			color: '#FFFFFF',
			opacity: 0.2,
		}
	},
	submitButton: {
		height: '50px',
		minWidth: '132px',
		borderRadius: '100px',
		color: '#000000',
		fontWeight: 500,
		fontSize: '12px',
		lineHeight: '14px',
		fontFamily: 'Integral CF, sans-serif',
		textTransform: 'uppercase',
		p: '10px 32px',
		backgroundColor: '#FFFFFF',

		'&:hover': {
			backgroundColor: '#000000',
			color: '#FFFFFF',
		},

		'&:active': {
			backgroundColor: '#000000',
			color: '#FFFFFF',
		},
	},
	checkBox: {
		color: '#FFFFFF',
		m: 0,
		gap: '12px',
		minWidth: '120px',

		'& .MuiStack-root': {
			flex: 1,
		},

		'& .MuiFormControlLabel-label, & a': {
			color: 'rgba(255, 255, 255, 0.7)',
			fontFamily: 'Montserrat',
			fontSize: '14px',
			fontWeight: 500,
			lineHeight: '21px',
			userSelect: 'none',

			'&.Mui-disabled': {
				color: 'rgba(255, 255, 255, 0.4)',
			},
		},

		'& a': {
			textUnderlineOffset: '1px',
			textDecorationThickness: '0.5px',
		},

		'& .MuiCheckbox-root': {
			height: '18px',
			width: '18px',
			p: 0,
			borderRadius: '4px',
			boxShadow: '0 0 0 1px #FFFFFF4D',
			backgroundColor: '#FFFFFF33',

			'&:hover': {
				backgroundColor: '#FFFFFF33',
				boxShadow: '0 0 0 1px #FFFFFF',
			},

			'& .MuiSvgIcon-root, & .MuiTouchRipple-root': {
				display: 'none',
			},

			'&.Mui-checked': {
				color: '#FFFFFF',
				boxShadow: '0 0 0 1px #FFFFFF4D',

				'& .MuiSvgIcon-root': {
					width: '14px',
					height: '14px',
					display: 'block',
				},
			}
		},
	},
	verificationTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '17px',
		fontWeight: 500,
		lineHeight: '20px',
		color: '#FFFFFF',
	},
	verificationDescription: {
		fontFamily: 'Montserrat',
		fontSize: '17px',
		fontWeight: 400,
		lineHeight: '21px',
		color: '#FFFFFF',
	},
	selectMembership: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		overflow: 'hidden',
		alignItems: 'center',
	},
	selectMembershipBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: '31px',
		flex: 1,
		overflow: 'hidden',
	},
	selectMembershipTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '24px',
		fontWeight: 600,
		color: Colors.white,
	},
	selectMembershipContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		flex: 1,
		overflow: 'hidden',
	},
	membershipsCards: {
		display: 'flex',
		flexWrap: 'wrap',
		flex: 1,
		overflow: 'auto',
		gap: '24px',
		maxHeight: 'fit-content',
		justifyContent: 'center',
	},
	selectMembershipNote: {
		p: '16px',
		borderRadius: '8px',
		backgroundColor: Colors.black_a20,
		fontFamily: 'General Sans, sans-serif',
		fontSize: '16px',
		fontWeight: 500,
		lineHeight: '18px',
		textAlign: 'center',
		color: Colors.white,
	},
});
